import { useState } from 'react'
import Modal from 'Shared/components/Modal/Modal'
import Select from 'react-select'
import ServerWaitButton from 'Shared/components/ServerWaitButtonStandalone'

export default function UpdateMembershipStatusModal({ open, onCancel, onConfirm }) {
  const [membershipStatus, setMembershipStatus] = useState('active')

  const membershipStatusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Ex-member' },
    { value: 'supporter', label: 'Supporter' }
  ]

  return (
    <Modal
      open={open}
      title="Update membership status for this audience"
      onCancel={onCancel}
    >
      <div className="row">
        <div className="field">
          <label className="bold margin-bottom">Membership Status</label>
          <Select
            options={membershipStatusOptions}
            value={membershipStatusOptions.find(option => option.value === membershipStatus)}
            onChange={(selectedOption) => setMembershipStatus(selectedOption.value)}
            classNamePrefix="membership-status-select"
            styles={{
              container: (baseStyles) => ({
                ...baseStyles,
                width: '200px',
              }),
            }}
          />
        </div>
      </div>

      <p className="bold">This will update the membership status for everyone in the audience to {membershipStatusOptions.find(option => option.value === membershipStatus)?.label}.</p>

      <div className="row">
        <ServerWaitButton
          className="button primary margin-top update-membership-status-button"
          onClick={() => onConfirm({ membershipStatus })}
        >
          Confirm
        </ServerWaitButton>
      </div>
    </Modal>
  )
}
